import gql from 'graphql-tag'

export const RETAILER_CHECKOUT_SUMMARY = gql`
    {
        viewer {
            checkoutSummary {
                shippingAddress {
                    companyName
                    street
                    houseNumber
                    postalCode
                    city
                    countryCode
                    phone
                }
                invoiceAddress {
                    companyName
                    street
                    houseNumber
                    postalCode
                    city
                    countryCode
                }
                isInvoiceAddressSame
                shouldShowBnplModal {
                    provider
                    show
                }
                availablePaymentMethods {
                    id
                    name
                    description
                    logos
                }
                paymentMethod {
                    id
                    name
                }
                carts {
                    id
                    storefronts {
                        name
                    }
                    subtotalPrice
                    oldSubtotalPrice
                    isTaxShifted
                }
                currency
                subtotalPrice
                shippingPrice
                oldRetailerShippingPrice
                taxPrice
                hasTaxShiftableOrder
                totalPrice
                hasImportDuties
                hasValidVatNumber
                voucherPrice
                processingFeePrice
                totalProductsCount
                originalSubtotalPrice
                orderDiscountAmount
                shippingSurchargePrice
            }
        }
    }
`

export const ADDRESS_BY_POSTAL_CODE = gql`
    mutation addressByPostalCode($input: AddressByPostalCodeInput!) {
        addressByPostalCode(input: $input) {
            street
            city
            userErrors {
                field
                message
            }
        }
    }
`

export const RETAILER_CHECKOUT_UPDATE = gql`
    mutation retailerCheckoutUpdate($input: RetailerCheckoutUpdateInput!) {
        retailerCheckoutUpdate(input: $input) {
            userErrors {
                field
                message
            }
        }
    }
`

export const BNPL_MODAL_UPDATE = gql`
    mutation bnplModalUpdate(
        $registeredCompanyName: String
        $street: String
        $houseNumber: String
        $postalCode: String
        $city: String
        $cocNumber: String
        $vatNumber: String
    ) {
        bnplModalUpdate(
            input: {
                registeredCompanyName: $registeredCompanyName
                street: $street
                houseNumber: $houseNumber
                postalCode: $postalCode
                city: $city
                cocNumber: $cocNumber
                vatNumber: $vatNumber
            }
        ) {
            account {
                street
                vatNumber
                cocNumber
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const RETAILER_CHECKOUT_CONVERT = gql`
    mutation retailerCheckoutConvert($input: RetailerCheckoutConvertInput!) {
        retailerCheckoutConvert(input: $input) {
            retailerOrder {
                id
                token
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const RETAILER_ORDER_PAY = gql`
    mutation retailerOrderPay($input: RetailerOrderPayInput!) {
        retailerOrderPay(input: $input) {
            success
            redirectUrl
            userErrors {
                field
                message
            }
        }
    }
`

export const RETAILER_ORDER_PAYMENT_SYNC = gql`
    mutation retailerOrderPaymentSync($input: RetailerOrderPaymentSyncInput!) {
        retailerOrderPaymentSync(input: $input) {
            success
            isPendingAuthorization
        }
    }
`

export const RETAILER_ORDER_ADDRESS_UPDATE = gql`
    mutation retailerOrderAddressUpdate(
        $input: RetailerOrderAddressUpdateInput!
    ) {
        retailerOrderAddressUpdate(input: $input) {
            success
        }
    }
`

export const RETAILER_ORDER_BY_PAYMENT_SLUG = gql`
    query retailerOrderTokenByPaymentSlug($paymentSlug: String!) {
        retailerOrderTokenByPaymentSlug(paymentSlug: $paymentSlug) {
            token
            isPaid
            isAuthorized
        }
    }
`

export const RETAILER_ORDER = gql`
    query retailerOrder($token: String!) {
        retailerOrderByToken(token: $token) {
            id
            databaseId
            token
            number
            currency
            createdAt
            companyName
            street
            houseNumber
            postalCode
            city
            country
            canChangeAddress
            isCreatedByBrand
            subtotalPrice
            voucherPrice
            shippingPrice
            taxPrice
            retailerProcessingFeePrice
            totalPrice
            amountDue
            isPaid
            isAuthorized
            hasPendingAuthorization
            status
            isSepaPayment
            staticPayment {
                amount
                externalPaymentDetails {
                    bankName
                    bankBic
                    bankAccount
                    reference
                }
            }
            paymentMethod {
                name
            }
            supplierOrders(first: 50) {
                edges {
                    node {
                        id
                        subtotalPrice
                        storefronts(first: 2) {
                            edges {
                                node {
                                    name
                                }
                            }
                        }
                    }
                }
            }
            availablePaymentMethods {
                id
                name
                description
                logos
            }
        }
    }
`

export const CHECKOUT_FEEDBACK = gql`
    mutation checkoutFeedbackCreate($input: CheckoutFeedbackCreateInput!) {
        checkoutFeedbackCreate(input: $input) {
            success
            userErrors {
                field
                message
            }
        }
    }
`

export const CHECKOUT_STARTED_EVENT = gql`
    mutation checkoutStartedEvent {
        checkoutStartedEvent {
            success
        }
    }
`
